(() => {
  const money = (cents) => {
    const currency = document.documentElement.dataset.currency || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];

  const routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : { root: '/' };
  const rootUrl = routes.root || '/';
  const route = (path) => rootUrl + path.replace(/^\//, '');

  const drawer = qs('[data-cart-drawer]');
  const overlay = qs('[data-cart-overlay]');

  function setOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) overlay.classList.toggle('is-visible', open);
    document.body.classList.toggle('cart-open', open);
  }

  function updateCartCount(cart) {
    qsa('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    qsa('[data-cart-count-label]').forEach(el => el.textContent = `(${cart.item_count})`);
  }

  function lineHtml(item) {
    const img = item.image ? `<img src="${item.image.replace(/'/g, '%27')}&width=180" alt="${item.title.replace(/"/g, '&quot;')}">` : '<div class="cart-line__placeholder">P</div>';
    return `<div class="cart-line" data-line="${item.key}">
      <div class="cart-line__media">${img}</div>
      <div class="cart-line__info">
        <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
        <div class="cart-line__controls">
          <button type="button" data-cart-change data-key="${item.key}" data-qty="${Math.max(item.quantity - 1, 0)}">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-change data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          <button class="cart-line__remove" type="button" data-cart-change data-key="${item.key}" data-qty="0">Remove</button>
        </div>
      </div>
    </div>`;
  }

  function renderCart(cart) {
    updateCartCount(cart);
    const body = qs('[data-cart-items]');
    const subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (body) {
      body.innerHTML = cart.item_count ? cart.items.map(lineHtml).join('') : `<div class="cart-empty"><div class="cart-empty__icon">◈</div><h3>Your cart is empty</h3><p>Add a premium access product to get started.</p><button class="btn secondary" type="button" data-cart-shop>Continue shopping</button></div>`;
    }
    renderCartPage(cart);
  }

  function renderCartPage(cart) {
    const wrap = qs('[data-cart-page]');
    if (!wrap) return;
    const content = qs('[data-cart-page-content]', wrap);
    if (!content) return;
    const subtotal = qs('[data-cart-page-subtotal]', wrap);
    if (subtotal) subtotal.textContent = money(cart.total_price);
    const items = qs('.cart-page-items', wrap);
    items.innerHTML = cart.item_count ? cart.items.map(lineHtml).join('') : `<div class="cart-empty cart-empty--page"><div class="cart-empty__icon">◈</div><h3>Your cart is empty</h3><p>Browse premium access options to get started.</p><a class="btn primary" href="/collections/all">Browse Products →</a></div>`;
  }

  async function fetchCart() {
    const res = await fetch(route('/cart.js'), { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  async function addToCart(form) {
    const btn = qs('.add-to-cart-btn', form);
    const label = qs('[data-add-label]', form);
    const original = label ? label.textContent : 'Add to Cart';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    try {
      const data = new FormData(form);
      const res = await fetch(route('/cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Unable to add to cart');
      }
      await fetchCart();
      if (label) label.textContent = 'Added';
      setOpen(true);
      setTimeout(() => { if (label) label.textContent = original; }, 1200);
    } catch (err) {
      alert(err.message || 'Something went wrong.');
      if (label) label.textContent = original;
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch(route('/cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('Unable to update cart');
      const cart = await res.json();
      renderCart(cart);
    } catch (err) { alert(err.message || 'Unable to update cart.'); }
  }

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-cart-open]');
    const close = e.target.closest('[data-cart-close]');
    const change = e.target.closest('[data-cart-change]');
    const shop = e.target.closest('[data-cart-shop]');
    if (open) { fetchCart().catch(() => {}); setOpen(true); }
    if (close || e.target === overlay) setOpen(false);
    if (shop) setOpen(false);
    if (change) changeLine(change.dataset.key, Number(change.dataset.qty));
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.nativeCart === 'true') return;
    if (!form.matches('.product-form, .access-form')) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', async e => {
    const buyNow = e.target.closest('[data-buy-now]');
    if (!buyNow) return;
    const form = buyNow.closest('.product-form');
    if (!form) return;
    buyNow.disabled = true;
    const originalText = buyNow.textContent;
    buyNow.textContent = 'Opening checkout…';
    try {
      const data = new FormData(form);
      const res = await fetch(route('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Unable to add the item to checkout.');
      }
      // Refresh the cart first so Shopify has the current cart state before checkout.
      await fetchCart();
      window.location.assign((routes.checkout_url || route('/checkout')));
    } catch (err) {
      alert(err.message || 'Unable to open checkout.');
      buyNow.disabled = false;
      buyNow.textContent = originalText;
    }
  });

  // Product variant selection: keep hidden variant id, availability and price in sync.
  qsa('[data-product-json]').forEach(node => {
    try {
      const product = JSON.parse(node.textContent);
      const form = node.closest('[data-product-section]')?.querySelector('.product-form');
      if (!form || !product?.variants?.length) return;
      const selects = qsa('[data-variant-option]', form);
      const idInput = qs('[data-variant-id]', form);
      const addBtn = qs('.add-to-cart-btn', form);
      const label = qs('[data-add-label]', form);
      const price = qs('[data-product-price]');
      const sync = () => {
        const values = selects.map(s => s.value);
        const variant = product.variants.find(v => v.options.every((value, i) => value === values[i])) || product.variants[0];
        if (idInput) idInput.value = variant.id;
        if (price && variant.price != null) price.textContent = money(variant.price);
        if (addBtn) addBtn.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      };
      selects.forEach(s => s.addEventListener('change', sync));
      sync();
    } catch (e) {}
  });

  // Smooth anchors without breaking normal links.
  qsa('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    const el = qs(a.getAttribute('href'));
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
  }));

  fetchCart().catch(() => {});
})();
